<template>
  <div>
    <a-layout id="components-layout-demo-side" style="background: white;">
      <a-layout-sider style="height:100%,padding:10px 0" width="150px">
        <SelectTree
          ref="myTree"
          :option="treeOption"
          @selectedTree="receiveData"
        />
      </a-layout-sider>
      <a-layout style="background: white;padding:10px">
        <data-table ref="dataTable" :option="option">
          <template #headAction>
            <a-button @click="checkInfo" style="margin-left:10px"
              >查看</a-button
            >
            <a-button @click="getDownLoad" style="margin-left:10px"
              >下载</a-button
            >
          </template>
          <template slot="mySlot">
            <upLoadImage v-model="backUrl" />
          </template>

          <template v-slot:state="slotProps">
            <a-badge v-if="slotProps" status="success" text="启用" />
            <a-badge v-else status="error" text="禁用" />
          </template>
        </data-table>
      </a-layout>
    </a-layout>

    <a-modal
      title="查看"
      :visible="windowVisible"
      @ok="windowSubmit"
      @cancel="windowCancel"
      :maskClosable="maskClickClose"
      width="800px"
    >
      <a-form class="ant-advanced-search-form" :form="form">
        <a-row type="flex" justify="space-around" align="middle">
          <a-col span="2">报表编码: </a-col>
          <a-col span="9">
            <a-input
              v-decorator="['Code']"
              :disabled="disabledState"
              :value="CodeVlaue"
            />
          </a-col>

          <a-col span="2">名称: </a-col>
          <a-col span="9">
            <a-input
              v-decorator="['Name']"
              :disabled="disabledState"
              :value="NameVlaue"
            />
          </a-col>
        </a-row>
        <a-row style="height:20px"> </a-row>
        <a-row type="flex" justify="space-around" align="middle">
          <a-col span="2">报表分组: </a-col>
          <a-col span="9">
            <a-input
              v-decorator="['Code']"
              :disabled="disabledState"
              :value="NameVlaue"
            />
          </a-col>

          <a-col span="2">排序: </a-col>
          <a-col span="9">
            <a-input
              v-decorator="['Order']"
              :disabled="disabledState"
              :value="OrderVlaue"
            />
          </a-col>
        </a-row>
        <a-row style="height:20px"> </a-row>
        <a-row type="flex" justify="space-around" align="middle">
          <a-col span="2">路径: </a-col>
          <a-col span="9">
            <a-input
              v-decorator="['Path']"
              :disabled="disabledState"
              :value="PathVlaue"
            />
          </a-col>
          <a-col span="2"></a-col>
          <a-col span="9"> </a-col>
        </a-row>
        <a-row style="height:20px"> </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import SelectTree from "@/components/dataTree/SelectTree";
import upLoadImage from "@/components/tools/upLoadImage";
import { DataTable } from "@/components/dataTable";
import { exportsDownLoad } from "@/utils/common";
import { cache } from "@/utils/common";
import ReportCenterTableModal from "./funtion.js";
import $config from "@/config/baseConfig";

export default {
  components: {
    SelectTree,
    upLoadImage,
    DataTable
  },
  data() {
    return {
      option: {},
      treeSelectCode: "",
      data: [],
      backUrl: "",

      windowVisible: false,
      maskClickClose: false,
      disabledState: true,
      form: this.$form.createForm(this),

      CodeVlaue: "",
      NameVlaue: "",
      OrderVlaue: "",
      PathVlaue: "",

      treeOption: {
        //URL数据请求地址
        api: "Role_GetReportGroupsAsync",
        //数据字段
        dataField: "Data",
        //标题字段
        title: "Name",
        //子数组字段
        children: "Childs",
        //选择值字段
        keyValue: "Id",
        //使用模式
        checkMode: "parentMode",
        params: { From: "maintenance" }
      }
    };
  },
  created() {
    const _this = this;
    _this.user = cache.get("user");
    _this.option = {
      headSearch: {
        colnum: 1, //表单列数
        content: [
          {
            label: "名称/代码",
            name: "Name",
            pressEnter: () => {
              this.$refs.dataTable.headSearch();
            }
          }
        ],
        onSubmitBefore: values => {
          _this.$refs.myTree.resetSelect();
          values.ReportGroupId = "";
          return values;
        }
      },
      form: {
        title: "报表", //表单标题
        width: 900, //宽度
        content: [
          {
            label: "报表编码",
            name: "Code",
            option: {
              rules: [{ required: true, message: "请输入代码!" }]
            }
          },
          {
            label: "名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请输入名称!" }]
            }
          },
          {
            label: "报表分组",
            name: "ReportGroupId",
            placeholder: "请选择分组",
            type: "select",
            api: "Role_GetReportGroupsAsync",
            param: { From: "maintenance" },
            dataField: "Data",
            valueField: "Id",
            textField: "Name",
            option: {
              rules: [{ required: true, message: "请选择一个分组!" }]
            }
          },
          {
            label: "排序",
            name: "Order",
            type: "number"
          },
          {
            label: "路径",
            slot: "mySlot"
          },
          {
            label: "描述",
            name: "Description"
          }
        ],
        add: {
          submitApi: "ReportMaintenance_Add",
          onSubmitBefore: values => {
            values.Path = _this.backUrl;
            let cutString = _this.$config.serverUrl + "/";
            let cutArray = values.Path.split(cutString);
            values.Path = cutArray[1];
            return values;
          }
        },
        edit: {
          infoApi: "ReportMaintenance_Get",
          submitApi: "ReportMaintenance_Edit",
          onSubmitBefore: values => {
            values.Path = _this.backUrl;
            return values;
          },
          onOpenBefore: () => {
            _this.backUrl = "";
          }
        },
        del: {
          submitApi: "ReportMaintenance_Del",
          onSubmitBefore: values => {
            return values;
          }
        }
      },
      grid: {
        //props: { scroll: { x: 980, y: 1000 } },
        api: "",
        params: {},
        columns: [
          {
            title: "序号",
            width: "6%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "代码",
            dataIndex: "Code",
            align: "center",
            width: "8%"
          },
          {
            title: "名称",
            dataIndex: "Name",
            align: "center",
            width: "12%"
          },
          {
            title: "报表说明",
            dataIndex: "Description",
            align: "center",
            width: "15%"
          },
          {
            title: "分组",
            dataIndex: "ReportGroupName",
            align: "center",
            width: "8%"
          },
          {
            title: "路径",
            dataIndex: "Path",
            align: "left"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "13%",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },

  methods: {
    receiveData(Data) {
      var _this = this;
      _this.treeSelectCode = Data.treeSelect;
      _this.option.grid.api = "ReportMaintenance_List";
      _this.option.grid.params = {
        PageIndex: 0,
        PageSize: 20,
        ReportGroupId: _this.treeSelectCode
      };
    },
    getDownLoad() {
      if (!this.$refs.dataTable.getSelected()) {
        this.$message.warning("请先选择行");
        return;
      } else {
        let url = this.$config.serverUrl + "" + "/api/Report/FileDown";
        exportsDownLoad(url, {
          Id: this.$refs.dataTable.getSelected().Id
        });
      }
    },
    checkInfo() {
      const _this = this;
      if (!_this.$refs.dataTable.getSelected()) {
        _this.$message.info("请选择报表!");
        return;
      }
      let serverUrl = $config.serverUrl;
      let code = _this.$refs.dataTable.getSelected().Code;
      let url =
        this.user.ReportUrl +
        "/show?reportid=" +
        code +
        "&url=" +
        serverUrl.substring(serverUrl.lastIndexOf("//") + 2, serverUrl.length) +
        "&Token=" +
        this.user.Token;
      ReportCenterTableModal({ title: "报表信息", width: "90%", url: url });
    },
    windowSubmit() {
      this.windowVisible = false;
    },
    windowCancel() {
      this.windowVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
